/**
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: Users add/edit page
  Date: April 25, 2020
**/

import React from 'react';
import {
  Grid,
  Typography,
  makeStyles,
  Dialog,
  DialogContent,
  Box,
  IconButton,
} from '@material-ui/core';

// import BackButton from '@material-ui/icons/ArrowBack';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { stringConstants } from '../../constants/stringConstants';
import MemberImportSummary from './memberImportSummary';
import GroupImportSummary from './groupImportSummary';
import GroupImportSummary2022 from './groupImportSummary2022';
import ProcedureCodeImports from './paProcedureCodeImports';
import ClientImportSummary from './clientImportSummary';
import CloseIcon from '@material-ui/icons/Close';

/** STYLES HERE * */
const useStyles = makeStyles(() => ({
  dialogmainwrapper: {
    minWidth: '700px',
    minHeight: '300px',
    padding: '30px 50px 50px',
  }
}));

const ImportResultsPage = (props) => {
  const { open, onCloseDialog, selectedJobID } = props;
  const classes = useStyles();
  const importState = useStoreState((state) => state.import);
  const commonAction = useStoreActions((actions) => actions.common);
  const importAction = useStoreActions((actions) => actions.import);

  React.useEffect(() => {
    importAction.setJob({});
    importAction
      .getJob(encodeURIComponent(selectedJobID))
      .then(function (response) {
        importAction.setJob(response.data.data);
        if (!response.data.data) {
          commonAction.setSubmitSnackbar({
            status: true,
            messages: stringConstants.noRecordFound,
            error: true,
          });
        }
      })
      .catch(function (error) {
        importAction.setJob({});
      });
  }, []);

  const showReportSummary = (jobData) => {
    if (jobData && jobData.import_code) {
      if (jobData.import_code === "bcbs_member_import") {
        return <MemberImportSummary job={jobData}></MemberImportSummary>
      }
      if (jobData.import_code === "itilitipa_procedures") {
        return <ProcedureCodeImports job={jobData}></ProcedureCodeImports>
      }
      if (jobData.import_code === "bcbsmn_groups_clients" || jobData.import_code === "bcbswy_client_import") {
        return <ClientImportSummary job={jobData}></ClientImportSummary>
      }
      if (jobData.import_code === "bcbs_programs_dxcode_services") {
        return <GroupImportSummary2022 job={jobData}></GroupImportSummary2022>
      }
      return <GroupImportSummary job={jobData}></GroupImportSummary>
    }
    return <GroupImportSummary job={jobData}></GroupImportSummary>
  }
  
  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="md"
      aria-labelledby="confirmation-dialog-title"
      open={open}
      PaperProps={{
        style: { borderRadius: 20 }
      }}
    >
      <Box className={classes.dialogmainwrapper}>
        <DialogContent>
          <Grid container>
            <Grid item md={12}>
              <Typography align="center" variant="h6" component="h6">Import Results</Typography>
              <IconButton
                style={{ position: 'absolute', top: '0px', right: '10px' }}
                color="primary"
                aria-label="Close"
                onClick={onCloseDialog}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
            {importState.job.report && (
              showReportSummary(importState.job)
            )}            
          </Grid>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default ImportResultsPage;
